import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import {
  ProfileDropdown,
  ThemeSegmentedToggle,
  toast,
  type ProfileDropdownUser,
} from '@rr/ui'
import {
  getUser,
  getAuthToken,
  setUser as cacheUser,
  clearAuth,
} from '@/lib/auth/session'
import { getCurrentUser } from '@/lib/api/auth'
import type { PlatformUser } from '@/types'

export default function UserMenu() {
  const navigate = useNavigate()
  const [user, setUser] = useState<PlatformUser | null>(null)

  useEffect(() => {
    let cancelled = false
    const cached = getUser()
    if (cached) {
      setUser(cached as PlatformUser)
      return
    }
    if (!getAuthToken()) return
    ;(async () => {
      try {
        const res: any = await getCurrentUser()
        const me = res?.data ?? res
        if (cancelled || !me) return
        cacheUser(me)
        setUser(me as PlatformUser)
      } catch {
        // No-op — auth guard will handle redirect.
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  if (!user) return null

  const profile: ProfileDropdownUser = {
    name: user.name,
    email: user.email ?? null,
  }

  return (
    <ProfileDropdown
      user={profile}
      onProfile={() => navigate('/tenants/profile')}
      onLogout={() => {
        clearAuth()
        toast('Logged out successfully', 'success')
        navigate('/login')
      }}
      contentClassName="w-72"
      extra={
        <div
          className="px-2 py-2"
          onClick={(e) => e.stopPropagation()}
          onPointerDown={(e) => e.stopPropagation()}
        >
          <ThemeSegmentedToggle label="Theme" />
        </div>
      }
    />
  )
}
